import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IPaymentTypeIdField {
	settingsId: string;
	onChange: (value: string) => void;
}

const PaymentTypeIdField: React.FC<IPaymentTypeIdField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterPaymentTypeId') }], [t]);

	return (
		<FormInput
			testId="PaymentTypeIdField"
			name={`paymentTypeId-${settingsId}`}
			label="paymentTypeIdLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(PaymentTypeIdField);
